/* eslint-disable @nx/enforce-module-boundaries */
import {
  PropertyInvestmentRoundObjectType,
  SecondaryMarketOffer,
} from '../../../../api-sdk/src/lib/properties/__generated__/sdk';

export function getMarketplaceOfferMinInvestmentAmount(
  offerId: string,
  investmentRound: PropertyInvestmentRoundObjectType
): number {
  const marketplaceOffer = getMarketplaceOfferInfo(offerId, investmentRound) || { minInvestment: 1 };

  return marketplaceOffer.minInvestment;
}

export function getMarketplaceOfferInfo(
  offerId: string,
  investmentRound: PropertyInvestmentRoundObjectType
): SecondaryMarketOffer | undefined {
  return investmentRound.activeSecondaryMarketOffers.find((offer) => offer.id === offerId);
}
